'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm4 8h-3v3h-2v-3H8V8h3V5h2v3h3v2z' });

var AddLocation = function AddLocation(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

AddLocation = (0, _pure2.default)(AddLocation);
AddLocation.muiName = 'SvgIcon';

exports.default = AddLocation;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/AddLocation.js
// module id = 2095
// module chunks = 0